import { useState } from 'react'
import { useSnapshot } from '../state/TelephonyProvider'
import { useCommand } from '../state/useCommand'
import { TelephonyCommandNames } from '../contract'
import type { CallRow } from '../state/store'
import { Lamp, callLampColor, prettyNumber, label } from './_shared'
import { TransferDialog } from './TransferDialog'
import {
  IconPlayerPause, IconPlayerPlay, IconParking, IconArrowsExchange, IconCircleDot, IconPhoneOff,
  IconPhoneCheck, IconPhoneX
} from '../ui/icons'

export function MyCallsPanel() {
  const { calls } = useSnapshot()
  const run = useCommand()
  const [transferCall, setTransferCall] = useState<CallRow | null>(null)

  return (
    <div className="sb-panel">
      {calls.length === 0 ? (
        <div className="sb-panel-empty">No active calls.</div>
      ) : (
        calls.map((c) => {
          const ringing = c.status === 'ringing'
          const active = c.status === 'connected' || c.status === 'on_hold'
          const name = c.callerIdName || prettyNumber(c.callerIdNumber) || c.channel
          return (
            <div key={c.uniqueId} className={active ? 'card card-active' : 'card'}>
              <div className="row">
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 600 }}>
                  <Lamp color={callLampColor(c.status)} />{name}
                </span>
                <span className="muted">{label(c.direction)} · {label(c.status)}</span>
              </div>
              <div className="muted" style={{ fontSize: 12 }}>
                {prettyNumber(c.callerIdNumber)} · ext {c.extension}
              </div>

              {ringing ? (
                <div className="btnrow">
                  <button className="btn btn-on"
                    onClick={() => void run(
                      { command: TelephonyCommandNames.Answer, params: { channel: c.channel } },
                      { successMessage: `Answered ${name}` }
                    )}>
                    <IconPhoneCheck size={14} stroke={1.75} /> answer
                  </button>
                  <button className="btn btn-danger"
                    onClick={() => void run({ command: TelephonyCommandNames.Reject, params: { channel: c.channel } })}>
                    <IconPhoneX size={14} stroke={1.75} /> reject
                  </button>
                </div>
              ) : (
                <div className="btnrow">
                  <button className={c.onHold ? 'btn btn-on' : 'btn'}
                    onClick={() => void run({
                      command: c.onHold ? TelephonyCommandNames.Unhold : TelephonyCommandNames.Hold,
                      params: { channel: c.channel }
                    })}>
                    {c.onHold ? <IconPlayerPlay size={14} stroke={1.75} /> : <IconPlayerPause size={14} stroke={1.75} />}
                    {c.onHold ? 'resume' : 'hold'}
                  </button>
                  <button className="btn"
                    onClick={() => void run({ command: TelephonyCommandNames.Park, params: { channel: c.channel } },
                      { successMessage: `Parked ${name}` })}>
                    <IconParking size={14} stroke={1.75} /> park
                  </button>
                  <button className="btn" onClick={() => setTransferCall(c)}>
                    <IconArrowsExchange size={14} stroke={1.75} /> transfer
                  </button>
                  <button className="btn"
                    onClick={() => void run({ command: TelephonyCommandNames.RecordStart, params: { channel: c.channel } },
                      { successMessage: 'Recording started' })}>
                    <IconCircleDot size={14} stroke={1.75} /> rec
                  </button>
                  <button className="btn btn-danger"
                    onClick={() => void run({ command: TelephonyCommandNames.Hangup, params: { channel: c.channel } })}>
                    <IconPhoneOff size={14} stroke={1.75} /> end
                  </button>
                </div>
              )}
            </div>
          )
        })
      )}
      {transferCall ? <TransferDialog call={transferCall} onClose={() => setTransferCall(null)} /> : null}
    </div>
  )
}
